<template>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
            v-model:loading="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="loadData"
        >
            <van-cell v-for="(item, index) in list" :key="index">
                <div class="container">
                    <div>
                        <van-button
                            v-if="item.Status === '空闲中'"
                            round
                            icon="play"
                            type="success"
                            size="small"
                            @click="runProcess(item.id)"
                            >空闲中
                        </van-button>
                        <van-button
                            v-else
                            round
                            icon="play"
                            :type="
                                item.Status === '运行中' ? 'primary' : 'default'
                            "
                            size="small"
                        >
                            {{ item.Status }}
                        </van-button>
                    </div>
                    <div>
                        <div>{{ item.processID }}</div>
                        <div>{{ item.processName }}</div>
                        <div>机器人：{{ item.Abbr }}({{ item.IsTest }})</div>
                    </div>
                </div>
            </van-cell>
        </van-list>
    </van-pull-refresh>
</template>

<script>
import { defineComponent, ref } from "vue";
import {
    List,
    Cell,
    Button,
    Notify,
    PullRefresh,
    showConfirmDialog,
    showNotify,
    closeNotify,
} from "vant";
import "vant/lib/index.css";
import Qs from "qs";

export default defineComponent({
    name: "ProcessRun",
    components: {
        [List.name]: List,
        [Cell.name]: Cell,
        [Button.name]: Button,
        [Notify.name]: Notify,
        [PullRefresh.name]: PullRefresh,
    },
    setup() {
        const list = ref([]);
        const loading = ref(false);
        const finished = ref(false);
        const currentPage = ref(1);
        const pageSize = ref(20);
        const totalResult = ref(0); //总数量
        const refreshing = ref(false);
        return {
            list,
            loading,
            finished,
            currentPage,
            pageSize,
            totalResult,
            refreshing,
        };
    },
    mounted() {
        this.loadData();
    },
    methods: {
        loadData() {
            if (this.refreshing) {
                this.list = [];
                this.refreshing = false;
            }
            if (this.totalResult === 0 || this.list.length === 0) {
                this.currentPage = 1;
            } else {
                if (
                    this.currentPage <
                    Math.ceil(this.totalResult / this.pageSize)
                ) {
                    this.currentPage++;
                }
            }

            // 模拟异步加载数据
            this.loading = true;
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: this.currentPage,
                pageSize: this.pageSize,
                searchKey: ["1"], //是否是首页查询 1 是 0 否
            };
            this.$api.jobManageAPI
                .getProcessTakeListMobile(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        showNotify({
                            type: "danger",
                            message: res.data.Message,
                        });
                        return;
                    }
                    this.list = [];
                    this.totalResult = res.data.Data.totalResult;
                    for (const row of res.data.Data.dataTable) {
                        this.list.push({
                            id: row.id,
                            processID: row.ProcessName,
                            processName: row.ProcessNo,
                            Status: row.Status,
                            Abbr: row.Abbr,
                            IsTest: row.IsTest,
                        });
                    }
                    if (this.list.length == res.data.Data.totalResult) {
                        this.finished = true;
                    }
                    this.loading = false;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        onRefresh() {
            // 清空列表数据
            this.finished = false;

            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.loading = true;
            this.loadData();
        },
        runProcess(processId) {
            showConfirmDialog({
                title: "提示",
                message: "您确定要执行该流程吗？",
            })
                .then(() => {
                    const params = {
                        uid: this.$store.state.userID,
                        email: this.$store.state.email,
                        actionType: "1",
                        actionKey: [
                            processId,
                            this.$store.state.userName,
                            "dd",
                        ], //dd 表示咚咚触发
                    };
                    this.$api.jobManageAPI
                        .startProcess(Qs.stringify(params))
                        .then((res) => {
                            if (res.data.Success == false) {
                                showNotify({
                                    type: "danger",
                                    message: res.data.Message,
                                });
                                return;
                            }
                            showNotify({
                                type: "success",
                                message:
                                    "流程已放入机器人队列当中，稍后将自动执行",
                            });

                            // console.log(res.data.Data);
                            this.loadData();
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                })
                .catch(() => {
                    // on cancel
                });
        },
    },
});
</script>

<style type="text/css">
.container {
    width: 100%;
    display: flex;
    justify-content: space-between;
}
</style>
